
if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }

    // helper to insert thousands/decimal delimiters
    formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
      const cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    // your money formatter
    formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || window.theme.moneyFormat;

      const match = formatString.match(placeholderRegex);
      const token = match && match[1];

      switch (token) {
        case 'amount':
          value = this.formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = this.formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = this.formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = this.formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = this.formatWithDelimiters(cents, 2, "'", ".");
          break;
        default:
          value = this.formatWithDelimiters(cents, 2);
      }

      return formatString.replace(placeholderRegex, value);
    }

    connectedCallback() {
      const amountText = this.querySelector('.free-shipping--text span');
      const total = parseInt(this.dataset.cartTotal, 10);
      const minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');

      if (total < minimum) {
        percentage = total / minimum;
        if (amountText) {
          const remaining = minimum - total;
          const fmt = window.theme.settings.money_with_currency_format || "${{amount}}";
          amountText.innerHTML = this.formatMoney(remaining, fmt);
        }
        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'block';
          this.fullText.style.display = 'none';
        }
      } else if (this.remainingText && this.fullText) {
        this.remainingText.style.display = 'none';
        this.fullText.style.display = 'block';
      }

      this.style.setProperty('--percentage', percentage);
    }
  }

  customElements.define('free-shipping', FreeShipping);
}

